import React,{useEffect, useState} from "react";
import BgImg from "../../images/logo/map-dotted.jpg";
const PageContainer = ({ ...props }) => {
  const [themeState] = useState({
    main: "default",
    sidebar: "dark",
    header: "white",
    skin: "light",
  });

  useEffect(() => {
    document.body.className = `nk-body bg-lighter npc-default has-sidebar no-touch nk-nio-theme ${
      themeState.skin === "dark" ? "dark-mode" : ""
    }`
  },[themeState.skin])

  return (
    <React.Fragment>
      <div className="nk-app-root"  style={{backgroundImage:`url(${BgImg})`}}>
        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content">{props.children}</div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default PageContainer;
